<template>
<div style="min-width:1500px">
    <div class="bgd-pink">
        <h1>Make every interaction with Beny more <br/>meaningful. </h1>
        <p class="new_topTip">Beny pledges 50% of profits towards creating a mentally healthier world.</p>
        <h2>
            Practising gratitude is a core part of our wellbeing journey. That’s why we donate 50% of profits to good causes like Black Dog<br/> Institute who share the same vision.
        </h2>
        <!--<button @click="jump('/works')">How it works</button>-->
    </div>
    <div class="black-wrap">
        <div class="bgd-black">
            <div class="video"></div>

            <!--<section class="employeesBox2">
                <h3>Beny in support of Beyond Blue</h3>
                <div class="employees_iconList">
                    <img class="employees_icon" src="../../assets/home/n1.png" alt="">
                    <img class="employees_icon" src="../../assets/home/n2.png" alt="">
                    <img class="employees_icon" src="../../assets/home/n3.png" alt="">
                    <img class="employees_icon" src="../../assets/home/n4.png" alt="">
                    <img class="employees_icon" src="../../assets/home/n5.png" alt="">
                    <img class="employees_icon" src="../../assets/home/n6.png" alt="">
                </div>
            </section>-->

            <!--<p>The most generous companies this year...</p>
            <ul>
                <li><a target="_blank">
                    <img src="../../assets/monthly/a.png" />
                </a></li>
                <li><a target="_blank">
                    <img src="../../assets/monthly/b.png" />
                </a></li>
                <li><a target="_blank">
                    <img src="../../assets/monthly/c.png" />
                </a></li>
                <li><a target="_blank">
                    <img src="../../assets/monthly/d.png" />
                </a></li>
                <li><a target="_blank">
                    <img src="../../assets/monthly/e.png" />
                </a></li>
                <li><a target="_blank">
                    <img src="../../assets/monthly/f.png" />
                </a></li>
                <li><a target="_blank">
                    <img src="../../assets/monthly/g.png" />
                </a></li>
            </ul>
            <div class="intro clear">
                <div class="rgt"></div>
                <div class="lft">
                    <h1>Track your impactaround the world</h1>
                    <h2>Lorem ipsum dolor sit amet, consectetur<br />
                    adipiscing elit. Aliquam sit amet vehicula orci.<br />
                    Duis sed laoreet erat. Integer rutrum metus ex.</h2>
                    <h3>"Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />
                    Aliquam sit amet vehicula orci. Duis sed laoreet erat.<br />
                    Integer rutrum metus ex."</h3>
                    <div class="avatar-introduce clear">
                        <div class="avatar" :style="{'backgroundImage': `url(${img})`}"></div>
                        <div class="introduce">
                            <strong>Sam Collins</strong>, CEO
                        </div>
                    </div>
                </div>
            </div>-->
            <div class="new_dog_box">
                <div class="bgd-logo"></div>
                <div class="dog_text">
                    The Black Dog Institute is a not-for-profit facility for diagnosis, treatment, and <br/>
                    prevention of mood disorders such as depression, anxiety, and bipolar disorder.<br/>
                    <div style="width: 100%;height: 11px;"></div>
                    To date, they are the only medical research institute in Australia to investigate <br/>
                    mental health across the lifespan.<br/>
                    <div style="width: 100%;height: 11px;"></div>
                    With a mission to create a mentally healthier world for everyone, The Black Dog <br/>
                    nstitute integrates their research studies, education programs, digital tools and <br/>
                    apps, clinical services, and public resources to find new solutions, foster <br/>
                    connections, and create real-world change.<br/>
                    <div style="width: 100%;height: 11px;"></div>
                    Our collective support in their important work enables them to drive meaningful <br/>
                    change in mental health where it’s needed the most.
                </div>
            </div>
        </div>
    </div>
    <div class="new_tit_btm">When you’re a part of Beny, you’re a part of our mission: focused on wellbeing and supporting good causes.</div>
    <!--<div class="grey-wrap">
        <div class="grey-bgd">
            <div class="content clear">
                <div class="rgt">
                    <div class="waterfall-temp"></div>
                    <div class="waterfall-container">
                        <div v-for="(item, index) in list" :key="index" class="waterfall-item">
                            <img :src="item.url" />
                        </div>
                    </div>
                </div>
                <div class="lft">
                    <h1>Donate to any idea<br />
                    you'd like to support</h1>
                    <h2>Lorem ipsum dolor sit amet, consectetur<br />
                    adipiscing elit. Aliquam sit amet vehicula orci.<br />
                    Duis sed laoreet erat. Integer rutrum metus ex.</h2>
                    <button>Start donating</button>
                </div>
            </div>
        </div>
    </div>
    <div class="black-wrap" style="margin-bottom:160px">
        <div class="bgd-black">
            <div class="intro clear">
                <div class="lft2"></div>
                <div class="rgt2">
                    <h1>"Lorem ipsum dolor sit amet,<br />
                    consectetur adipiscing elit, sed do<br />
                    eiusmod tempor incididunt ut labore<br />
                    et dolore magna aliqua. Ut enim ad<br />
                    minim veniam, quis nostrud<br />
                    exercitation ullamco laboris nisi ut<br />
                    aliquip ex ea commodo consequat.<br />
                    Duis aute irure dolor."</h1>
                    <div class="avatar-introduce clear">
                        <div class="avatar" :style="{'backgroundImage': `url(${img})`}"></div>
                        <div class="introduce">
                            <strong>Thomas Stevens</strong>, UX/UI Designer
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->
    <div class="tow-boxs">
        <div class="lft"></div>
        <div class="pink">
            <div class="spaceone"></div>
            <div class="content">
                <h1>Become a Beny<br />organisation</h1>
                <h2>
                    Ready to become fast friends with Beny? Sign up
                    now, quicker than it takes to brew a cup of
                    coffee and give your employees not only access
                    to 1000’s of big-name benefits, but the valuable
                    wellness and wellbeing support that gets them
                    from nine to thrive.
                </h2>
                <div class="button" @click="jump('/registered')">Get started</div>
            </div>
            <div class="spacetow"></div>
            <div class="img"></div>
            <div class="spacethree"></div>
        </div>
        <div class="center"></div>
        <div class="pink">
            <div class="spaceone"></div>
            <div class="content">
                <h1>Become a Beny Partner</h1>
                <h2>
                    Interested in partnering up with Beny for 
                    Business? The Beny network spans across 
                    thousands of Australian businesses providing an 
                    expansive range of B2B products and services. 
                    Your organisation can be a part of our circle. 
                    Partner with Beny and offer benefits to win 
                    more customers.
                </h2>
                <div class="button" style="margin-bottom: 40px;" @click="jump('/partner')">Become a partner</div>
            </div>
            <div class="spacetow"></div>
            <div class="img2"></div>
            <div class="spacethree"></div>
        </div>
        <div class="rgt"></div>
    </div>
</div>
</template>

<script>
import img from '../../assets/monthly/4.png'

export default {
    data () {
        return {
            img: img,
            list: [
                {
                    url: 'https://i.pinimg.com/originals/7c/ce/06/7cce0693dc9370ff4f8b09f6d44f302b.png'
                },
                {
                    url: 'https://i.pinimg.com/originals/10/61/27/106127d6697cb6e6bf5e5cf4834eea0f.png'
                },
                {
                    url: 'https://i.pinimg.com/originals/0f/c7/ef/0fc7efa86d5f24b377fb5ea250cf186a.jpg'
                },
                {
                    url: 'https://i.pinimg.com/originals/e4/cf/3c/e4cf3c66e1ea4d6971729dc91a28cda6.jpg'
                },
                {
                    url: 'https://i.pinimg.com/originals/8e/40/4a/8e404a744406991a0de70beed44d44e5.jpg'
                }
            ]
        }
    },
    methods: {
        jump (path) {
            this.$router.push(path)
        },
    }
}
</script>

<style lang="scss" scope>
.bgd-pink{
    width: 100%;
    padding-top: 127px;
    background: #F1DADD;
    height: 690px;
    box-sizing: border-box;
    h1{
        text-align: center;
        margin-bottom: 18px;
        font-size: 52px;
        font-family: DIN Next LT Pro-Black, DIN Next LT Pro;
        font-weight: 900;
        color: #3A3835;
        line-height: 61px;
    }
    h2{
        text-align: center;
        margin-bottom: 24px;
        font-size: 18px;
        font-family: Assistant-Medium, Assistant;
        font-weight: 500;
        color: #3A3835;
        line-height: 21px;
    }
    .new_topTip{
        text-align: center;
        font-size: 22px;
        font-family: Lora-Regular, Lora;
        font-weight: 400;
        color: #3A3835;
        line-height: 28px;
        margin: 20px 0;
    }
    button{
        margin: 0 auto;
        border: none;
        cursor: pointer;
        display: block;
        width: 170px;
        height: 54px;
        background: #F8A4AE;
        border-radius: 4px;
        font-size: 17px;
        font-family: Assistant;
        font-weight: bold;
        color: #3A3835;
    }
}
.black-wrap{
    width: 100%;
    box-sizing: border-box;
    padding: 0 40px;
    .bgd-black{
        background: #3A3835;
        .video{
            width: 1160px;
            height: 617px;
            margin: 0 auto;
            background-size: cover;
            background-image: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/6e36771a224a4a77802ba671cbbf94bd.png');
            position: relative;
            top: -240px;
            margin-bottom: -240px;
            .icon{
                width: 94px;
                height: 100px;
                margin: 0 auto;
                background-size: contain;
                background-position: center top;
                background-repeat: no-repeat;
                background-image: url('../../assets/monthly/v1.png');
                cursor: pointer;
                position: relative;
                top: 260px;
            }
        }
        .new_dog_box{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 100px 0 70px 0;
            .bgd-logo{
                width: 600px;
                min-width: 600px;
                height: 300px;
                background-size: contain;
                background-position: center center;
                background-repeat: no-repeat;
                background-image: url('../../assets/monthly/logo.png');
            }
            .dog_text{
                // flex: 1;
                width: 660px;
                margin-left: 60px;
                font-size: 17px;
                font-family: Lora-Regular, Lora;
                font-weight: 400;
                color: rgba($color: #FFFFFF, $alpha: 0.8);
                line-height: 21px;
            }
        }
        .employeesBox2{
            width: 1140px;
            margin: -180px auto 0 auto;
            padding: 0;
            h3{
                text-align: center;
                width: 100%;
                font-size: 18px;
                font-weight: 400;
                line-height: 27px;
                color: #FFFFFF;
                opacity: 0.8;
            }
            .employees_iconList{
                margin: 34px 0 130px 0;
                padding-left:28px;
                display: flex;
                height: 26px;
                align-items: center;
                .employees_icon{
                    height: 54px;
                    margin-right: 50px;
                    &:nth-last-child(1){
                        margin-right: 0;
                    }
                }
            }
            .employess_bigBox{
                display: flex;
                .employee_bigLeft{
                    width: 470px;
                    min-width: 470px;
                    height: 498px;
                    background: #F0F0F0;
                    opacity: 1;
                    background: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/7d1a924cad8f4ad3958e2c68d5ecd039.png') no-repeat;
                    background-size: contain;
                    border-radius: 8px;
                }
                .employee_bigRight{
                    margin-left: 72px;
                    .bigRight_tit{
                        margin-top: 54px;
                        width: 100%;
                        font-size: 40px;
                        font-weight: bold;
                        line-height: 44px;
                        color: #FFFFFF;
                        opacity: 1;
                    }
                    .bigRight_text{
                        font-size: 17px;
                        font-weight: 400;
                        line-height: 21px;
                        color: #FFFFFF;
                        opacity: 0.8;
                        margin: 20px 0 40px 0;
                    }
                    .bigRight_Choose{
                        height: 25px;
                        font-size: 18px;
                        font-weight: 400;
                        line-height: 25px;
                        color: #FFFFFF;
                        opacity: 1;
                        margin-bottom: 30px;
                        &::before{
                            display: inline-block;
                            content: ' ';
                            vertical-align: sub;
                            width: 21px;
                            height: 21px;
                            margin-right: 10px;
                            background: url('../../assets/home/checked.png') no-repeat;
                            background-size: contain;
                        }
                    }
                }
            }
        }

        p{
            text-align: center;
            margin: -180px 0 34px 0;
            font-size: 18px;
            font-family: Assistant;
            font-weight: 400;
            color: #D7D7D6;
        }
        ul{
            text-align: center;
            li{
                display: inline-block;
                padding: 0 25px;
                vertical-align: top;
                a{
                    display: inline-block;
                    img{
                        width: 100%;
                    }
                }
            }
            li:nth-child(1) a {
                width: 121px;
            }
            li:nth-child(2) a {
                width: 123px;
            }
            li:nth-child(3) a {
                width: 105px;
            }
            li:nth-child(4) a {
                width: 103px;
            }
            li:nth-child(5) a {
                width: 78px;
            }
            li:nth-child(6) a {
                width: 102px;
            }
            li:nth-child(7) a {
                width: 82px;
            }
        }
        .intro{
            width: 1480px;
            margin: 0 auto;
            .lft{
                float: left;
                margin-left: 190px;
                width: 420px;
                padding-top: 197px;
                h1{
                    word-break: break-word;
                    margin-bottom: 20px;
                    font-size: 40px;
                    font-family: Assistant;
                    font-weight: bold;
                    line-height: 44px;
                    color: #FFFFFF;
                }
                h2{
                    word-break: break-word;
                    font-size: 17px;
                    font-family: Assistant;
                    font-weight: 400;
                    line-height: 21px;
                    color: #FFFFFF;
                    padding-bottom: 31px;
                    border-bottom: 1px dashed #5E5C59;
                    margin-bottom: 23px;
                }
                h3{
                    word-break: break-word;
                    font-size: 15px;
                    font-family: Assistant;
                    font-weight: 400;
                    line-height: 18px;
                    color: #D7D7D6;
                    margin-bottom: 24px;
                }
                .avatar-introduce{
                    .avatar{
                        width: 40px;
                        height: 40px;
                        background: #E6E6E6;
                        border-radius: 50%;
                        float: left;
                        margin-right: 10px;
                    }
                    .introduce{
                        font-size: 15px;
                        font-family: Assistant;
                        font-weight: 400;
                        line-height: 22px;
                        color: #FFFFFF;
                        float: left;
                        padding-top: 10px;
                    }
                }
            }
            .rgt{
                float: right;
                width: 746px;
                height: 749px;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center center;
                background-image: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/55cadd32ba63460db8c5263cedc272dc.png');
            }
            .lft2{
                width: 500px;
                height: 544px;
                background-size: cover;
                background-image: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/b5f4e09dc19f4ad9805eccfafcea0669.png');
                border-radius: 4px;
                margin: 0 110px 0 190px;
                float: left;
            }
            .rgt2{
                float: left;
                h1{
                    font-size: 24px;
                    font-family: Lora;
                    font-weight: normal;
                    line-height: 30px;
                    color: #FFFFFF;
                    word-break: break-word;
                    width: 650px;
                    margin-bottom: 24px;
                }
                .avatar-introduce{
                    .avatar{
                        width: 40px;
                        height: 40px;
                        background: #E6E6E6;
                        border-radius: 50%;
                        float: left;
                        margin-right: 10px;
                        background-repeat: no-repeat;
                        background-size: contain;
                        background-position: center center;
                    }
                    .introduce{
                        font-size: 15px;
                        font-family: Assistant;
                        font-weight: 400;
                        line-height: 22px;
                        color: #FFFFFF;
                        float: left;
                        padding-top: 10px;
                    }
                }
            }
        }
    }
}
.new_tit_btm{
    max-width: 1320px;
    font-size: 40px;
    font-family: Assistant-Medium, Assistant;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 47px;
    text-align: center;
    margin: 0 auto;
    padding-bottom: 200px;
}
.grey-wrap{
    width: 100%;
    box-sizing: border-box;
    padding: 0 40px;
    margin-bottom: 160px;
    .grey-bgd{
        width: 100%;
        height: 720px;
        border-radius: 8px;
        background: #4d4c4a;
        .content{
            width: 1480px;
            margin: 0 auto;
            .rgt{
                width: 720px;
                float: right;
                height: 720px;
                overflow-x: hidden;
                overflow-y: auto;
                scrollbar-width: none; /* Firefox */
                -ms-overflow-style: none; /* IE 10+ */
                .waterfall-container {
                    width: 692px;
                    /*分几列*/
                    column-count: 2;
                    -moz-column-count:2; /* Firefox */
                    -webkit-column-count:2; /* Safari and Chrome */
                    column-gap: 20px;
                    column-width: 336px;
                    -moz-column-width: 336px; /* Firefox */
                    -webkit-column-width: 336px; /* Safari and Chrome */
                }
                .waterfall-temp{
                    width: 692px;
                    height: 720px;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    background-image: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/b45e74d1316047158ecc214e91a148db.png');
                    -webkit-filter: grayscale(100%);
                    -moz-filter: grayscale(100%);
                    -ms-filter: grayscale(100%);
                    -o-filter: grayscale(100%);
                    filter: grayscale(100%);
                    filter: gray;
                }
                .waterfall-item {
                    /*不留白，不知道什么意思可以取消这个样式试试*/
                    break-inside: avoid;
                    margin: 0 0 20px 0;
                    border-radius: 10px;
                    overflow: hidden;
                    column-gap: 20px;
                    -moz-column-gap:20px; /* Firefox */
                    -webkit-column-gap:20px; /* Safari 和 Chrome */
                    img{
                        width: 100%;
                    }
                }
            }
            .rgt::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
            .lft{
                padding-top: 78px;
                float: left;
                margin-left: 190px;
                h1{
                    padding-top: 135px;
                    font-size: 40px;
                    font-family: DIN Next LT Pro-Black, DIN Next LT Pro;
                    color: #3A3835;
                    line-height: 48px;
                    color: #3A3835;
                    margin-bottom: 17px;
                    word-break: break-word;
                }
                h2{
                    font-size: 18px;
                    font-family: Assistant-Medium, Assistant;
                    font-weight: 500;
                    color: #3A3835;
                    line-height: 21px;
                    word-break: break-word;
                    margin-bottom: 24px;
                }
                .button{
                    width: 222px;
                    height: 54px;
                    line-height: 54px;
                    cursor: pointer;
                    background: #F8A4AE;
                    border-radius: 4px;
                    text-align: center;
                    font-size: 17px;
                    font-family: Assistant-Bold;
                    font-weight: bold;
                    color: #3A3835;
                }
            }
        }
    }
}
.tow-boxs{
    width: 100%;
    display: flex;
    flex-direction: row;
    .lft, .rgt{
        width: 40px;
        flex: 0 0 auto;
    }
    .center{
        width: 20px;
        flex: 0 0 auto;
    }
    .pink{
        min-height: 446px;
        height: 510px;
        flex: 1;
        background: #F1DADD;
        display: flex;
        flex-direction: row;
        .spaceone, .spacetow{
            flex: 5;
        }
        .spacethree{
            flex: 4;
        }
        .content{
            width: 320px;
            h1{
                padding-top: 128px;
                font-size: 40px;
                font-family: DIN Next LT Pro-Black, DIN Next LT Pro;
                font-weight: 900;
                color: #3A3835;
                line-height: 48px;
                margin-bottom: 17px;
                word-break: break-word;
            }
            h2{
                font-size: 18px;
                font-family: Assistant-Medium, Assistant;
                font-weight: 500;
                color: #3A3835;
                line-height: 22px;
                word-break: break-word;
                margin-bottom: 24px;
            }
            .button{
                width: 222px;
                height: 54px;
                line-height: 54px;
                cursor: pointer;
                background: #F8A4AE;
                border-radius: 4px;
                text-align: center;
                font-size: 17px;
                font-family: Assistant-Bold, Assistant;
                font-weight: bold;
                color: #3A3835;
            }
        }
        .img{
            width: 326px;
            height: 326px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            background-image: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/92075fac249c4af394b7c251e8411163.png');
            margin-top: 60px;
        }
        .img2{
            width: 326px;
            height: 326px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            background-image: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/015a58311b5f41469cf07ae27c5a814a.png');
            margin-top: 60px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/monthlyCharity/monthlyCharity.vue